export default {
  user(state) {
    return state.user;
  },
  organizationId(state) {
    return state.organizationId;
  },
  userId(state) {
    return state.userId;
  },
  userType() {
    let user = JSON.parse(localStorage.getItem("loggedInUser"));
    return user.onboardingtype;
  },
  isLoggedIn() {
    if (localStorage.getItem("token")) {
      return true;
    } else {
      return false;
    }
  },
  googleApiKey(state){
     return state.google_api_key
  },
  userAccountType(){
    let user = JSON.parse(localStorage.getItem("loggedInUser"));
    if(user.onboardingtype === "3PL" && user.accounttype === "individual"){
      return "solo_operator"
    }else if(user.onboardingtype === "3PL" && user.accounttype === "organization"){
      return "enterprise_partner";
    }else if(user.onboardingtype === "ondemand" && user.accounttype === "individual"){
      return "private_customer"
    }else if(user.onboardingtype === "organization" && user.accounttype === "individual"){
      return "enterprise_customer"
    }else {
      return "invalid_user"
    }
  }
};
